var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.18 27.34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.45,21.73l-.08-1a9,9,0,0,1,2.43-6.79c1.77-2.08,2.75-3.61,2.75-5.38,0-2-1.25-3.34-3.73-3.38a7,7,0,0,0-4,1.22L9.91,3.9a10.35,10.35,0,0,1,5.62-1.57c4.52,0,6.56,2.79,6.56,5.78,0,2.67-1.49,4.59-3.38,6.83a7.74,7.74,0,0,0-2.24,5.77l0,1Zm-.87,5.5a2.32,2.32,0,0,1,2.36-2.47,2.29,2.29,0,0,1,2.32,2.47,2.34,2.34,0,1,1-4.68,0Z",
    transform: "translate(-9.91 -2.33)"
  })));
}

export default SvgQuestion;